import React from 'react';
import './AppStoreRedirect.css';

const AppStoreRedirect: React.FC = () => {
  const handleDownloadApp = () => {
    // Go to PhomoCam on the App Store
    window.location.href = 'https://apps.apple.com/us/app/phomocam/id6751013049';
  };

  return (
    <div className="app-store-redirect-container">
      {/* App Logo */}
      <div className="logo-container">
        <img
          src="/favicon.png"
          alt="Phomo Logo"
          className="logo-image"
        />
      </div>

      {/* App Info */}
      <div className="app-info-container">
        <h1 className="app-title">
          PhomoCam
        </h1>

        <p className="app-description">
          Share photos instantly with AI-powered face recognition.
          Download the app to join events and share memories with friends.
        </p>

        {/* Features */}
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🤖</div>
            <div className="feature-title">AI Face Recognition</div>
            <div className="feature-description">Automatically find yourself in shared photos</div>
          </div>

          <div className="feature-card">
            <div className="feature-icon">👥</div>
            <div className="feature-title">Shared Events</div>
            <div className="feature-description">Create group events for occasions and trips</div>
          </div>
        </div>
      </div>

      {/* Download Button */}
      <div className="download-container">
        <button
          onClick={handleDownloadApp}
          className="download-button"
        >
          <span className="download-button-icon">📱</span>
          Download on the App Store
        </button>
      </div>

      {/* Footer */}
      <div className="footer">
        <div className="footer-links">
          <a href="/privacy" className="footer-link">
            Privacy Policy
          </a>
          <a href="/terms" className="footer-link">
            Terms of Service
          </a>
          <a href="/support" className="footer-link">
            Support
          </a>
        </div>
        © 2025 PhomoCam. Share memories, not just photos.
      </div>
    </div>
  );
};

export default AppStoreRedirect;